/**
 * Gera slug de rota a partir do nome do relatório (minúsculo, sem acentos).
 * @param {string} name
 * @returns {string}
 */
export function getReportLinkSlug(name) {
  return String(name ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}
